import React, { ChangeEvent } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { FormControl } from "@mui/material";

type ObjProps = {
  name: string;
  id: string;
};
type DropdownProps = {
  obj: ObjProps[];
  value: ObjProps;
  handleChange: (event: React.ChangeEvent, newValue: ObjProps | null) => void;
  disable?: boolean;
};

const ComboBox = (props: DropdownProps) => {
  const { obj, value, handleChange, disable } = props;

  const handleSelectionChange = (
    event: ChangeEvent<any>,
    newValue: ObjProps | null
  ) => {
    handleChange(event, newValue);
  };
  return (
    <FormControl
      sx={{ width: "100%" }}
      size="small"
      style={{ cursor: "pointer" }}
    >
      <Autocomplete
        size="small"
        value={value}
        disabled={disable}
        onChange={handleSelectionChange}
        options={obj}
        getOptionLabel={(option: ObjProps) => option.name}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              "& .MuiInputBase-root": {
                fontSize: "14px",
                color: "black",
                fontFamily: "Poppins",
              },
            }}
            inputProps={{
              ...params.inputProps,
              "aria-label": "Choose a language",
            }}
          />
        )}
      />
    </FormControl>
  );
};

export default ComboBox;
